<template>
  <VuePerfectScrollbar
    class="history-area"
    :settings="settings"
  >
    <div
      class="org-tree-container"
      id="luongXuLy"
    >
      <div
        class="org-tree"
        :class="{horizontal, collapsable}"
      >
        <org-tree-node
          :data="data"
          :props="props"
          :horizontal="horizontal"
          :label-width="labelWidth"
          :collapsable="collapsable"
          :render-content="renderContent"
          :label-class-name="labelClassName"
          @on-expand="$emit('onExpand', $event)"
          @on-node-click="(e, data) => {$emit('onNodeClick', e, data)}"
        ></org-tree-node>
      </div>
    </div>
  </VuePerfectScrollbar>
</template>
<script>
import render from './node'
import VuePerfectScrollbar from "vue-perfect-scrollbar"

export default {
  name: 'Vue2OrgTree',
  components: {
    VuePerfectScrollbar,
    OrgTreeNode: {
      render,
      functional: true
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      default: () => ({
        label: 'label',
        expand: 'expand',
        children: 'children',
        moreInfo: 'moreInfo'
      })
    },
    horizontal: Boolean,
    collapsable: Boolean,
    renderContent: Function,
    labelWidth: [String, Number],
    labelClassName: [Function, String]
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 750
      },
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/doc-out/components/vue2-tree/components/org-tree/org-tree.vue